'use client';

import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { sessionStorageHelper } from '@core/Utils/SessionStorageHelper';

export const finCalcInteractedWithAtom = atom<boolean>(false);

export const finCalcInteractedWithStorageAtom = atomWithStorage<boolean>(
  'finCalcInteractedWith',
  false,
  sessionStorageHelper as any,
);
